module.exports = __webpack_public_path__ + "img/banner3_5_th.12521cb1.png";